const VitalLogoSvg = () => {
  return (
    <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="250"
        cy="250"
        r="200"
        stroke="white"
        strokeWidth="10"
        strokeDasharray="10 10"
        opacity="0.2"
      />
      <circle
        cx="250"
        cy="250"
        r="180"
        stroke="url(#paint0_linear)"
        strokeWidth="20"
      />
      <path
        d="M150 310L220 240L280 280L350 180"
        stroke="#10b981"
        strokeWidth="18"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <animate
          attributeName="stroke-dasharray"
          from="0,1000"
          to="1000,0"
          dur="2s"
        />
      </path>
      <circle cx="350" cy="180" r="12" fill="#38bdf8">
        <animate
          attributeName="r"
          values="8;15;8"
          dur="1.5s"
          repeatCount="indefinite"
        />
      </circle>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="70"
          y1="70"
          x2="430"
          y2="430"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.9" />
          <stop offset="1" stopColor="#38bdf8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default VitalLogoSvg;
